// import Sidebar from "./Sidebar";
// import Header from "./Header";

// const Layout = ({ children }) => (
//     <div className="flex min-h-screen overflow-x-hidden">
//         <Sidebar />
//         <div className="flex-1 flex flex-col ml-64 min-w-0">
//             <Header />
//             <main className="flex-1 bg-[var(--bg-light)] p-0.5 pr-0 overflow-y-auto overflow-x-hidden mt-16 max-w-full">{children}</main>
//         </div>
//     </div>
// );

// export default Layout; 




import { useState } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";

const Layout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="flex min-h-screen overflow-x-hidden">

      <Sidebar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
      />

      <div
        className={`
          flex-1
          flex
          flex-col
          min-w-0
          transition-all
          duration-300
          ease-in-out
          ${collapsed ? "ml-20" : "ml-64"}
        `}
      >
        <Header collapsed={collapsed} setCollapsed={setCollapsed}/>

        <main className="flex-1 bg-[var(--bg-light)] p-0.5 pr-0 overflow-y-auto overflow-x-hidden mt-16 max-w-full">
          {children}
        </main>
      </div>

    </div>
  );
};

export default Layout;